export default __webpack_public_path__ + "static/media/puff.be69e7a9.svg";